import { defineStore } from 'pinia'
import { services } from '@/assets/js/config.js';
import { useHttpStore } from './httpStore';

export const useProposalStore = defineStore('proposalStore', {
  state: () => ({
		activeProposal:{},
		approvalSettings:[],
  }),
  getters: {
	},
  actions: {
		getApprovalSettingList(params={}) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.initial_proposal}approval-setings`, params).then((resp) => {
          httpStore.convertPaginationKeys(resp.data);
					this.approvalSettings = resp.data.data
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

		getProposal(psal_id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.initial_proposal}proposal/detail/${psal_id}`, params).then((resp) => {
          this.activeProposal = resp.data
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

		syncToSas(psal_id = null) {
			const httpStore = useHttpStore();
			httpStore.post(`${services.initial_proposal}proposal/sync-lms/${psal_id}`).then((resp) => {
				return resp.data;
			}).catch(err => {
				_gNotif.cLog(err);
			});
		}
  }
})